import { render } from "./indexHome.vue?vue&type=template&id=04fbb004"
import script from "./indexHome.vue?vue&type=script&lang=js"
export * from "./indexHome.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__